import { render, staticRenderFns } from "./FaIcon.vue?vue&type=template&id=35cf5cb2&"
import script from "./FaIcon.vue?vue&type=script&lang=js&"
export * from "./FaIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports